<!-- 最小流量分析详情 -->
<template>
  <j-modal
    :title="title"
    width="70%"
    :visible="visible"
    switchFullscreen
    @ok="handleOk"
    :body-style="{ height: '580px', overflow: 'hidden', overflowY: 'scroll' }"
    :okButtonProps="{ class: { 'jee-hidden': true } }"
    @cancel="handleCancel"
    :cancelText="$t('关闭')"
  >
    <a-spin :spinning="confirmLoading">
      <!-- 查询区域 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline" @keyup.enter.native="searchQuery">
          <a-row :gutter="24">
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('起止日期')">
                <a-range-picker
                  v-model="date"
                  value-format="YYYY-MM-DD"
                  :placeholder="$t('请选择起止日期')"
                  style="width: 100%"
                />
              </a-form-item>
            </a-col>
            <a-col :xl="18" :lg="7" :md="8" :sm="24">
              <span style="overflow: hidden" class="table-page-search-submitButtons">
                <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
                <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
                <a-radio-group
                  v-model="radioValue"
                  style="margin-left: 8px; float: right"
                  button-style="solid"
                  @change="changeRadio"
                >
                  <a-radio-button value="1">
                    <a-icon type="table" />
                  </a-radio-button>
                  <a-radio-button value="2">
                    <a-icon type="line-chart" />
                  </a-radio-button>
                </a-radio-group>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 查询区域-END -->

      <!-- table区域-begin -->
      <div v-if="radioValue == 1">
        <a-table
          ref="table"
          size="middle"
          :scroll="{ x: true }"
          bordered
          rowKey="id"
          :columns="columns"
          :dataSource="dataSource"
          :pagination="false"
          class="j-table-force-nowrap"
        >
          <template slot="htmlSlot" slot-scope="text">
            <div v-html="text"></div>
          </template>
          <template slot="imgSlot" slot-scope="text, record">
            <span v-if="!text" style="font-size: 12px; font-style: italic">{{ $t('无图片') }}</span>
            <img
              v-else
              :src="getImgView(text)"
              :preview="record.id"
              height="25px"
              alt=""
              style="max-width: 80px; font-size: 12px; font-style: italic"
            />
          </template>
          <template slot="fileSlot" slot-scope="text">
            <span v-if="!text" style="font-size: 12px; font-style: italic">{{ $t('无文件') }}</span>
            <a-button v-else :ghost="true" type="primary" icon="download" size="small" @click="downloadFile(text)">
              {{ $t('下载') }}
            </a-button>
          </template>
          <template slot="userName" slot-scope="text, record">
            <a @click="handleDetail(record)">{{ text }}</a>
          </template>
        </a-table>
      </div>
      <div v-else>
        <div id="chart" style="width: 100%; height: 400px"></div>
      </div>
    </a-spin>
  </j-modal>
</template>
          
  <script>
import { httpAction, getAction, postAction } from '@/api/manage'
import * as echarts from 'echarts'
import axios from 'axios'
export default {
  name: 'MinimumFlowAnalysisModal',
  components: {},
  data() {
    return {
      title: '',
      width: 800,
      visible: false,
      disableSubmit: false,
      model: {},
      confirmLoading: false,
      url: {
        list: '/mock/MinimumFlowAnalysis/getMinimumFlowAnalysisList',
      },
      dataSource1: [
        {
          id: 1,
          date: '2025-06-20',
          nightMinimumFlow: 0,
          nightMinimumFlowTime: '1996-06-20',
          nightMinimumFlowInstantaneous: 0,
          nightMinimumFlowInstantaneousTime: '1996-06-20',
          nightMaximumFlowInstantaneous: 0,
          nightAverageFlow: 0,
          nightMinimumFlowRatio: 0,
        },
        {
          id: 2,
          date: '2025-01-16',
          nightMinimumFlow: 0,
          nightMinimumFlowTime: '1975-11-16',
          nightMinimumFlowInstantaneous: 0,
          nightMinimumFlowInstantaneousTime: '1975-11-16',
          nightMaximumFlowInstantaneous: 0,
          nightAverageFlow: 0,
          nightMinimumFlowRatio: 0,
        },
        {
          id: 3,
          date: '2025-01-30',
          nightMinimumFlow: 0,
          nightMinimumFlowTime: '1995-01-30',
          nightMinimumFlowInstantaneous: 0,
          nightMinimumFlowInstantaneousTime: '1995-01-30',
          nightMaximumFlowInstantaneous: 0,
          nightAverageFlow: 0,
          nightMinimumFlowRatio: 0,
        },
        {
          id: 4,
          date: '2025-07-22',
          nightMinimumFlow: 0,
          nightMinimumFlowTime: '2006-07-22',
          nightMinimumFlowInstantaneous: 0,
          nightMinimumFlowInstantaneousTime: '2006-07-22',
          nightMaximumFlowInstantaneous: 0,
          nightAverageFlow: 0,
          nightMinimumFlowRatio: 0,
        },
        {
          id: 5,
          date: '2025-05-27',
          nightMinimumFlow: 0,
          nightMinimumFlowTime: '1981-05-27',
          nightMinimumFlowInstantaneous: 0,
          nightMinimumFlowInstantaneousTime: '1981-05-27',
          nightMaximumFlowInstantaneous: 0,
          nightAverageFlow: 0,
          nightMinimumFlowRatio: 0,
        },
        {
          id: 13,
          date: '2025-09-20',
          nightMinimumFlow: 0,
          nightMinimumFlowTime: '2002-09-20',
          nightMinimumFlowInstantaneous: 0,
          nightMinimumFlowInstantaneousTime: '2002-09-20',
          nightMaximumFlowInstantaneous: 0,
          nightAverageFlow: 0,
          nightMinimumFlowRatio: 0,
        },
        {
          id: 14,
          date: '2025-07-29',
          nightMinimumFlow: 0,
          nightMinimumFlowTime: '1992-09-29',
          nightMinimumFlowInstantaneous: 0,
          nightMinimumFlowInstantaneousTime: '1992-09-29',
          nightMaximumFlowInstantaneous: 0,
          nightAverageFlow: 0,
          nightMinimumFlowRatio: 0,
        },
      ],
      queryParam: {},
      radioValue: '1',
      date: [],
      dataSource: []
    }
  },
  computed: {
    // i18n：表头使用 computed 以响应语言切换（分区名称列以当前记录的分区名作为表头）
    columns() {
      return [
        {
          title: this.$t('时间'),
          dataIndex: 'date',
          align: 'center',
        },
        {
          title: this.model.partitionName,
          dataIndex: 'partitionName',
          align: 'center',
          children: [
            {
              title: this.$t('夜间最小流量'),
              dataIndex: 'nightMinimumFlow',
              align: 'center',
            },
            {
              title: this.$t('出现时间'),
              dataIndex: 'nightMinimumFlowTime',
              align: 'center',
            },
            {
              title: this.$t('最小瞬时(m³/h)'),
              dataIndex: 'nightMinimumFlowInstantaneous',
              align: 'center',
            },
            {
              title: this.$t('出现时间'),
              dataIndex: 'nightMinimumFlowInstantaneousTime',
              align: 'center',
            },
            {
              title: this.$t('最大瞬时(m³/h)'),
              dataIndex: 'nightMaximumFlowInstantaneous',
              align: 'center',
            },
            {
              title: this.$t('平均水量(m³/h)'),
              dataIndex: 'nightAverageFlow',
              align: 'center',
            },
            {
              title: this.$t('夜间最小流量占比(%)'),
              dataIndex: 'nightMinimumFlowRatio',
              align: 'center',
            },
          ],
        },
      ]
    },
  },
  methods: {
    add() {
      this.edit({})
    },
    edit(record) {
      this.model = Object.assign({}, record)
      this.title = this.$t('最小流量分析详情')
      this.visible = true
      this.loadData();
      // this.getMinimumFlowAnalysisList()
    },
    loadData(){
      if(this.date.length==2){
        this.dataSource = this.dataSource1.filter(item=>{
          return item.date>=this.date[0]&&item.date<=this.date[1]
        })
      }else{
        this.dataSource = this.dataSource1
      }
    },
    // async getMinimumFlowAnalysisList() {
    //   try {
    //     let params = {
    //       partitionName: this.model.partitionName,
    //       startTime: this.date[0],
    //       endTime: this.date[1],
    //     }
    //     const res = await axios.post(this.url.list, params)
    //     if (res.data.code == 200) {
    //       this.dataSource = res.data.result
    //       console.log(this.dataSource)
    //     } else {
    //       this.dataSource = []
    //       this.$message.error(res.data.message)
    //     }
    //   } catch (err) {
    //     console.log(err)
    //   }
    // },
    close() {
      this.$emit('close')
      this.visible = false
    },
    handleOk() {},
    handleCancel() {
      this.close()
    },
    changeRadio(e) {
      if (e.target.value == 1) {
      } else {
        this.$nextTick(() => {
          this.setChart()
        })
      }
    },
    setChart() {
      var chart = echarts.init(document.getElementById('chart'))
      var option = {
        title: {
          text: this.$t('最小流量分析'),
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            animation: false,
          },
        },
        legend: {},
        xAxis: {
          data: this.dataSource.map(item => item.date),
        },
        yAxis: {},
        series: [
          {
            name: this.$t('夜间最小流量'),
            type: 'line',
            data: this.dataSource.map(item => item.nightMinimumFlow),
          },
          {
            name: this.$t('最小瞬时'),
            type: 'line',
            data: this.dataSource.map(item => item.nightMinimumFlowInstantaneous),
          },
          {
            name: this.$t('最大瞬时'),
            type: 'line',
            data: this.dataSource.map(item => item.nightMaximumFlowInstantaneous),
          },
          {
            name: this.$t('平均水量'),
            type: 'line',
            data: this.dataSource.map(item => item.nightAverageFlow),
          },
          {
            name: this.$t('夜间最小流量占比'),
            type: 'line',
            data: this.dataSource.map(item => item.nightMinimumFlowRatio),
          },
        ],
      }
      chart.setOption(option)
      window.addEventListener('resize', function () {
        chart.resize()
      })
    },
    searchQuery() {
      this.loadData()
    },
    searchReset() {
      this.date = []
      this.loadData()
    },
  },
}
</script>
        <style scoped>
.table-fixed /deep/ .ant-table-bordered .ant-table-fixed-left table {
  border-right: 1px solid #e8e8e8;
}

.table-fixed /deep/ .resize-table-th {
  position: relative;
}
.table-fixed /deep/ .table-draggable-handle {
  border: 1px solid red;
  height: 100% !important;
  left: auto !important;
  right: -5px;
  cursor: col-resize;
  touch-action: none;
  border: none;
  position: absolute;
  transform: none !important;
  bottom: 0;
}
</style>